
import {
    CheckOutlined,
    ClockCircleOutlined,
    DownOutlined,
    LoadingOutlined,
    StopOutlined,
    UpOutlined,
} from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { AiStep, AiMessageStatus } from '../vitrual-assistant.type';

interface AiStepsProps {
    steps: AiStep[];
    status: AiMessageStatus;
    startedAt: number;
    finishedAt?: number;
    hasText: boolean;
}

const formatDuration = (durationMs: number): string => {
    return `${(Math.max(0, durationMs) / 1000).toFixed(1).replace('.', ',')} с`;
};

const AiSteps: React.FC<AiStepsProps> = ({
    steps,
    status,
    startedAt,
    finishedAt,
    hasText,
}) => {
    const [now, setNow] = useState(Date.now);
    const [userExpanded, setUserExpanded] = useState<boolean | null>(null);

    const isStreaming = status === 'streaming';

    useEffect(() => {
        if (!isStreaming) return;

        const interval = window.setInterval(() => {
            setNow(Date.now());
        }, 100);

        return () => window.clearInterval(interval);
    }, [isStreaming]);

    const expanded = userExpanded !== null
        ? userExpanded
        : isStreaming;

    const totalDuration = (finishedAt ?? now) - startedAt;

    const currentStep = [...steps]
        .reverse()
        .find(step => step.status === 'running');

    const headerText = isStreaming
        ? currentStep?.displayName || currentStep?.node || 'Обрабатываю запрос'
        : status === 'completed'
            ? `Готово за ${formatDuration(totalDuration)}`
            : status === 'stopped'
                ? `Остановлено через ${formatDuration(totalDuration)}`
                : 'Обработка прервана';

    return (
        <div className="message__ai_progress">
            <button
                type="button"
                className="message__ai_progress_header"
                onClick={() => setUserExpanded(!expanded)}
                aria-expanded={expanded}
                disabled={!steps.length}
            >
                <span className="message__ai_progress_title">
                    {isStreaming ? (
                        <LoadingOutlined spin />
                    ) : status === 'completed' ? (
                        <CheckOutlined />
                    ) : (
                        <StopOutlined />
                    )}

                    <span>{headerText}</span>
                </span>

                <span className="message__ai_progress_right">
                    {isStreaming && (
                        <span>{formatDuration(totalDuration)}</span>
                    )}

                    {steps.length > 0 && (
                        expanded ? <UpOutlined /> : <DownOutlined />
                    )}
                </span>
            </button>

            {expanded && steps.length > 0 && (
                <div className="message__ai_progress_list">
                    {steps.map(step => {
                        const running = step.status === 'running'
                            && isStreaming;

                        const elapsedMs = running
                            ? now - (step.startedAt ?? startedAt)
                            : step.durationMs;

                        return (
                            <div
                                className="message__ai_progress_step"
                                key={step.id}
                            >
                                <span className="message__ai_progress_icon">
                                    {running ? (
                                        <LoadingOutlined spin />
                                    ) : step.status === 'done' ? (
                                        <CheckOutlined />
                                    ) : (
                                        <ClockCircleOutlined />
                                    )}
                                </span>

                                <span className="message__ai_progress_label">
                                    {step.displayName || step.node || 'Обработка'}
                                </span>

                                <span className="message__ai_progress_time">
                                    {elapsedMs != null
                                        ? formatDuration(elapsedMs)
                                        : ''}
                                </span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default AiSteps;
